/* ===========================
   CWC As Seen On - Swiper Init
   =========================== */

document.addEventListener("DOMContentLoaded", function () {
  const MOBILE_BREAKPOINT = 768;
  const swiperContainers = document.querySelectorAll(".cwc-as-seen-on__swiper");

  swiperContainers.forEach((container) => {
    const sectionId = container.dataset.sectionId;
    const section = document.getElementById(`cwc-as-seen-on-${sectionId}`);
    
    // Get settings from section (passed via inline script or defaults)
    const autoplay = section?.dataset.autoplay !== "false";
    const autoplaySpeed = parseInt(section?.dataset.autoplaySpeed) || 3000;

    let swiperInstance = null;

    function initSwiper() {
      // Only initialize on mobile
      if (window.innerWidth > MOBILE_BREAKPOINT) {
        if (swiperInstance) {
          swiperInstance.destroy(true, true);
          swiperInstance = null;
        }
        return;
      }

      // Don't reinitialize if already exists
      if (swiperInstance) return;

      swiperInstance = new Swiper(container, {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        centeredSlides: true,
        grabCursor: true,

        // Autoplay
        autoplay: autoplay ? {
          delay: autoplaySpeed,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        } : false,

        // Navigation arrows
        navigation: {
          prevEl: container.querySelector(".cwc-as-seen-on__nav-prev"),
          nextEl: container.querySelector(".cwc-as-seen-on__nav-next")
        },

        // Accessibility
        a11y: {
          prevSlideMessage: "Previous logo",
          nextSlideMessage: "Next logo"
        }
      });
    }

    // Initialize on load
    initSwiper();

    // Handle resize (debounced)
    let resizeTimeout;
    window.addEventListener("resize", function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(initSwiper, 200);
    });
  });
});
